import { render, staticRenderFns } from "./MyIOSPrivacy.vue?vue&type=template&id=96e596b2&scoped=true"
import script from "./MyIOSPrivacy.vue?vue&type=script&lang=js"
export * from "./MyIOSPrivacy.vue?vue&type=script&lang=js"
import style0 from "./MyIOSPrivacy.vue?vue&type=style&index=0&id=96e596b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e596b2",
  null
  
)

export default component.exports